<template>
  <div
      class="product-card block bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden cursor-pointer"
  >
    <!-- 点击跳详情 -->
    <div @click="goDetail">
      <div class="relative bg-gray-100 p-2 rounded-t-xl flex justify-center items-center">
        <img
            :src="product.images?.[0] || ''"
            class="
            object-contain rounded-lg
            w-[180px] h-[180px]
            sm:w-[200px] sm:h-[200px]
            md:w-[220px] md:h-[220px]
            lg:w-[260px] lg:h-[260px]
          "
        />
      </div>

      <!-- 商品信息 -->
      <div class="p-3 pt-2">
        <p class="text-xs text-gray-500 mb-0.5">{{ product.material || '' }}</p>
        <p class="text-sm font-medium text-gray-800 line-clamp-2 h-10 mb-1">
          {{ product.title || '' }}
        </p>
        <div class="mt-1">
          <span class="text-xl font-extrabold text-red-600-light">
            ¥{{ ((product.price || 0) / 100).toFixed(0) }}
          </span>
          <span class="text-xs text-gray-500 ml-1">{{ product.onlookers || 0 }}人关注</span>
        </div>
      </div>
    </div>

    <!-- 货号 + 回传按钮 -->
    <div class="px-3 pb-3 text-center">
      <p class="text-sm text-gray-700 mb-2">
        货号：<span class="font-bold">{{ product.articleNumber || '-' }}</span>
      </p>
    </div>
  </div>
</template>

<script>
import { sendNumberBack } from '@/api/dewu.js'

export default {
  name: 'ProductCard',
  props: {
    product: { type: Object, required: true }
  },
  data() {
    return {
      sent: false
    }
  },
  emits: ['open'],
  methods: {

    /** 清空组件数据（供父组件调用） */
    reset() {
      this.sent = false
    },
    /** 跳转至详情页（必须传 params 才不会报错） */
    goDetail() {
      if (!this.product?.spuId) return

      // this.$router.push({
      //   name: 'ProductDetail',
      //   params: {
      //     spuId: this.product.spuId   // ⭐ 必须在 params 里
      //   },
      //   query: {
      //     title: this.product.title || '',
      //     hh: this.product.articleNumber || '',
      //     img: this.product.images?.[0] || ''
      //   }
      // })
      this.$emit('open', {
        spuId: this.product.spuId,
        queryInfo: {
          title: this.product.title || '',
          hh: this.product.articleNumber || '',
          img: this.product.images?.[0] || ''
        }
      })
    },

    /** 回传货号 */
    async handleNumberBack() {
      const wxLoginToken = localStorage.getItem('wxLoginToken')
      if (!wxLoginToken) {
        alert('请先设置 wxLoginToken')
        return
      }

      const number = this.product.articleNumber
      if (!number) return alert('未获取到货号')

      try {
        await sendNumberBack(number, '多货号', wxLoginToken)
        this.sent = true
      } catch (err) {
        console.error('货号回传失败:', err)
        alert('货号回传失败，请检查控制台')
      }
    }
  }
}
</script>
